import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { travelTitle, travelList, travelListAd, travelHardAd, promoteInTravel },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip id="230183" type="struct" title="旅游标题" groupName="旅游" content={travelTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="225740"
                    type="recommend"
                    title="旅游列表"
                    groupName="旅游"
                    content={travelList}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" ad={travelListAd} />
                </Chip>
                <NoSSR>
                    <Ad content={travelHardAd} styleName={styles.dbox} />
                </NoSSR>
                {promoteInTravel && (
                    <Chip id="230194" type="struct" title="铺底推广" groupName="旅游" content={promoteInTravel}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
